import TickerItems from "../TickerItems";
import { SHOW_STANDINGS } from "../../constants-ticker";
import {
  createStandingItem,
  createStandingPhaseItem,
  getBaseballStages,
  getBaseballConferences,
  getBaseballDivisions,
  getBaseballTeams,
  getBaseballRecord,
  getBaseballTeamName,
} from "./tickerSportUtils";

/**
 * Contenido MLB (sport_code BASE).
 *
 * A diferencia de FOOT, los standings de baseball se agrupan por conferencia
 * (American/National League). El título de cada sección es el nombre de la
 * conferencia y cada equipo muestra su abreviatura junto al récord de
 * ganados-perdidos y su porcentaje.
 */
export default function BaseballTickerContent({ standing }) {
  const stages = getBaseballStages(standing);

  const standings = SHOW_STANDINGS ? stages.flatMap((stage) => {
    const conferences = getBaseballConferences(stage);

    return conferences.flatMap((conference) => {
      const divisions = getBaseballDivisions(conference);
      // Todos los equipos de la conferencia, recorriendo sus divisiones.
      const teams = divisions.flatMap((division) => getBaseballTeams(division));
      if (!teams.length) return [];

      return [
        // Título de la sección: nombre de la conferencia (ej. "American League").
        createStandingPhaseItem(conference?.name || conference?.abbreviation || "Liga"),
        ...teams.map((team, index) => {
          const wins = team?.record?.wins ?? team?.wins;
          const losses = team?.record?.losses ?? team?.losses;
          const percentage = team?.record?.percentage ?? team?.record?.winPercentage ?? team?.percentage ?? "";

          return createStandingItem({
            entry: {
              rank: team?.division?.rank ?? team?.rank ?? index + 1,
            },
            fallbackRank: index + 1,
            image: team?.image || team?.logo || "",
            name: getBaseballTeamName(team),
            points: getBaseballRecord(team),
            pointsLabel: "",
            // Récord desglosado con etiquetas: (W) 80 (L) 80 (PCT) .544
            stats: [
              { label: "W", value: wins },
              { label: "L", value: losses },
              { label: "PCT", value: percentage },
            ],
          });
        }),
      ];
    });
  }) : [];

  return <TickerItems items={standings} />;
}
